__turbopack_context__.v({
  "column": "WhatTabContent-module__EziQqG__column",
  "columnItem": "WhatTabContent-module__EziQqG__columnItem",
  "columnItemsWrapper": "WhatTabContent-module__EziQqG__columnItemsWrapper",
  "columnsSection": "WhatTabContent-module__EziQqG__columnsSection",
  "highlightsSection": "WhatTabContent-module__EziQqG__highlightsSection",
  "menuImagesWrapper": "WhatTabContent-module__EziQqG__menuImagesWrapper",
  "separator": "WhatTabContent-module__EziQqG__separator",
  "tabContent": "WhatTabContent-module__EziQqG__tabContent",
  "title": "WhatTabContent-module__EziQqG__title",
});
